/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Inject, Injectable, InjectionToken } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

export const TRANSLATE_LAZY_CONFIG = new InjectionToken<string>('TRANSLATE_LAZY_CONFIG');

@Injectable()
export class TranslateLazyService {
  readonly prefix: string = '/assets/i18n/';
  readonly suffix: string = '.json';

  constructor(
    @Inject(TRANSLATE_LAZY_CONFIG) private config: {prefix: string; suffix: string},
    private translateService: TranslateService,
    private httpClient: HttpClient
  ) {
    if (config && config.prefix) {
      this.prefix = config.prefix;
    }
    if (config && config.suffix) {
      this.suffix = config.suffix;
    }
    const lang = this.translateService.currentLang;
    this.fetchLang(lang);
    this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.fetchLang(langChangeEvent.lang);
    });
  }

  fetchLang(lang: string) {
    this.httpClient.get(`${this.prefix}${lang}${this.suffix}`).subscribe((res) => {
      this.translateService.setTranslation(lang, res, true);
    });
  }
}
